import React from "react";
import "./FormulaBar.css";

/**
 * FormulaBar
 * Excel-style top bar: name box (A1 / range label), the static "fx" badge,
 * and a read-only display of the active cell's value or formula.
 */
function FormulaBar({ selectedCellLabel, selectionSummary, selectedCellText }) {
  const isFormula = selectedCellText.startsWith("=");
  const inputClass = [
    "simple-excel-formula-input",
    selectionSummary ? "formula-bar-selection"
      : isFormula ? "formula-bar-formula" : "",
  ].join(" ").trim();

  return (
    <div className="simple-excel-formula-bar">
      <div className="simple-excel-name-box">{selectedCellLabel}</div>
      <div className="simple-excel-fx-btn" title="Formula">
        <em>f</em><sub>x</sub>
      </div>
      <div className={inputClass} title={selectedCellText}>
        {selectionSummary ? `Selection: ${selectionSummary}` : selectedCellText}
      </div>
    </div>
  );
}

export default React.memo(FormulaBar);
